import { configureStore ,combineReducers} from '@reduxjs/toolkit'
import counterReducer from './counterSlice'
import storageSession from 'redux-persist/lib/storage/session'
import { persistReducer } from 'redux-persist'
import questionReducer from './QuestionPaperSlice'
import needAttentionReducer from './needAttentionSlice'

// export default configureStore({
//   reducer: {
//     teacherIds: counterReducer,
//   },
// })

const persistConfig = {
  key: 'auth',
  storage: storageSession,
}

export const teacherReducer = combineReducers({
  teacherIds: counterReducer,
  questionData: questionReducer,
  needAttentionData:needAttentionReducer
})


const persistedReducer = persistReducer(persistConfig, teacherReducer)

const store = configureStore({
  reducer: persistedReducer
})

export default store